import React from 'react'
import { useTranslation } from 'react-i18next'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import Button from '../../../../components/Button'
import Icon from '../../../../components/Icon'

import { onAuthLinkClickHandler } from './helpers'

import { ReactComponent as DV360Icon } from '../../../../assets/logos/dv360-icon.svg'
import { ReactComponent as GoogleIcon } from '../../../../assets/logos/google-icon.svg'
import { ReactComponent as TikTikIcon } from '../../../../assets/logos/tt-icon.svg'

import {
  DV_360_PLATFORM,
  FACEBOOK_PLATFORM,
  GOOGLE_PLATFORM,
  TIKTOK_PLATFORM
} from '../../../../constants/selectLists/platformList'

import useStyles from './style'

function SocialAuthorizeButtons({ selectedPlatform, buttonClassName }) {
  const classes = useStyles()

  const { t } = useTranslation()

  return (
    <>
      {selectedPlatform === FACEBOOK_PLATFORM && (
        <a
          href="/api/allauth/facebook/login/?process=connect"
          rel="noreferrer nofollow"
          onClick={onAuthLinkClickHandler}
        >
          <Button solid className={classnames(classes.facebookBtn, buttonClassName)} type="button">
            {t('Continue with Facebook')}
          </Button>
        </a>
      )}
      {selectedPlatform === GOOGLE_PLATFORM && (
        <a href="/api/allauth/google/login/?process=connect" rel="noreferrer nofollow" onClick={onAuthLinkClickHandler}>
          <Button solid className={classnames(classes.googleButton, buttonClassName)} type="button">
            <Icon className={classes.googleButtonIcon}>
              <GoogleIcon />
            </Icon>
            <span className={classes.googleButtonText}>{t('Authenticate with Google Ads')}</span>
          </Button>
        </a>
      )}
      {selectedPlatform === DV_360_PLATFORM && (
        <a href="/api/allauth/dv360/login/?process=connect" rel="noreferrer nofollow" onClick={onAuthLinkClickHandler}>
          <Button solid className={classnames(classes.dv360Button, buttonClassName)} type="button">
            <Icon className={classes.googleButtonIcon}>
              <DV360Icon />
            </Icon>
            <span className={classes.googleButtonText}>{t('Authenticate with Display Video 360')}</span>
          </Button>
        </a>
      )}
      {selectedPlatform === TIKTOK_PLATFORM && (
        <a href="/api/allauth/tiktok/login/?process=connect" rel="noreferrer nofollow" onClick={onAuthLinkClickHandler}>
          <Button solid className={classnames(classes.tikTokButton, buttonClassName)} type="button">
            <TikTikIcon className={classes.tikTokIcon} />
            <span className="text">{t('Continue with TikTok')}</span>
          </Button>
        </a>
      )}
    </>
  )
}

SocialAuthorizeButtons.propTypes = {
  selectedPlatform: PropTypes.string.isRequired,
  buttonClassName: PropTypes.string
}

export default SocialAuthorizeButtons
